import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Teodor Sandu
 * id E5A72C59-D7AF-47F4-939E-F9F882E3F2FF
 * name shipping-pallet
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shipping-pallet.svg
 * tags
 */
export const ShippingPalletIcon = createSvgIcon(<><path d="M3 20H5V18H11V20H13V18H19V20H21V15H19V16H17V15H15V16H13V15H11V16H9V15H7V16H5V15H3M5 13H19V4H5Z" /></>, 'ShippingPalletIcon');
export default ShippingPalletIcon